import React from "react";
import NavbarProgram from "../../components/NavbarProgram";
import { Helmet } from "react-helmet";
import { googleFormEnglish } from "../../constant";
import { programData, ProgramType } from "../../data/programData";
import PaymentSection from "../../components/paymentSection";
import ServiceProcess from "../../components/serviceProcess";

const features = [
  {
    title: "About Section Enhancement",
    description:
      "Transform your experience into a compelling narrative to showcase potential and personality to recruiters.",
  },
  {
    title: "Post & Activity Guide",
    description:
      "Provide post examples and activity strategies to increase recruiter visibility and networking opportunities.",
  },
  {
    title: "Experience Section Optimization",
    description:
      "Rewrite your experience section to highlight key achievements and UK-style expressions for clarity.",
  },
  {
    title: "Education Section Refinement",
    description:
      "Concise, UK-standard education descriptions to increase professional credibility.",
  },
  {
    title: "Profile Photo & Headline Feedback",
    description:
      "Professional tone and style improvements for photo, headline, and summary to enhance visual branding.",
  },
  {
    title: "Keyword Optimization (ATS & SEO)",
    description:
      "Insert industry-specific keywords to maximize profile visibility on LinkedIn and applicant tracking systems.",
  },
];

const LinkedInPage: React.FC = () => {
  const program = programData.find(p => p.id === ProgramType.LinkedIn)!;
  
  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>BeMe – LinkedIn Consulting</title>
        <meta
          name="description"
          content="Maximize your recruiter visibility with BeMe's UK-focused LinkedIn Consulting service."
        />
      </Helmet>

      <NavbarProgram />

      {/* Hero Section */}
      <section className="bg-main text-white py-20 px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">LinkedIn Consulting</h1>
        <p className="max-w-2xl mx-auto text-lg md:text-xl text-sub/90 mb-8">
          Beyond just an online profile—create a global personal brand that stands out to UK
          recruiters.
        </p>
        <a
          href={googleFormEnglish}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-accent text-white px-8 py-3 rounded-lg font-semibold shadow-md hover:bg-yellow-600 transition-colors"
        >
          Apply Now
        </a>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-sub">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-main text-center mb-12">What You'll Get</h2>
          <div className="grid md:grid-cols-2 gap-10">
            {features.map((f, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-main mb-2">{f.title}</h3>
                <p className="text-gray-700">{f.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 px-4 text-center">
        <ServiceProcess label={program.label} />
      </section>

      {/* Differentiation Section */}
      <section className="py-16 bg-sub">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-main mb-6">Why BeMe is Different</h2>
          <p className="text-gray-700 text-lg">
            Unlike simple profile editing services, BeMe Consulting combines UK recruiter keyword
            optimization, ATS & SEO strategies, activity guidance, and 1:1 expert support to
            maximize LinkedIn visibility and career impact.
          </p>
        </div>
        
      </section>

      <section className="bg-white py-20 px-4 text-center">
        <PaymentSection program={program} />
      </section>
    </div>
  );
};

export default LinkedInPage;
